import { render, staticRenderFns } from "./ContractSelection.vue?vue&type=template&id=0b008cc7&"
import script from "./ContractSelection.vue?vue&type=script&lang=js&"
export * from "./ContractSelection.vue?vue&type=script&lang=js&"
import style0 from "./ContractSelection.vue?vue&type=style&index=0&id=0b008cc7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports